<template>
  <div class="mainPage">
    <!-- 메인 슬라이더 -->
    <div class="mainSlider">
      <!-- 로그인 상태 -->
      <carousel
        v-if="isLogin"
        :perPage="1"
        :paginationPadding="2"
        :autoplay="true"
        :autoplayTimeout="5000"
        :loop="true"
        ref="loginMain"
      >
        <slide
          v-for="(slide, index) in slider"
          v-if="slide.login_state === 'Y' || slide.login_state === 'S'"
          :key="index"
          :data-index="index"
          class="slide"
        >
          <div class="sliderInner">
            <p v-if="slide.title" class="title" v-html="slide.title"></p>
            <p v-if="slide.content" class="desc" v-html="slide.content"></p>

            <!-- 버튼 (외부 링크/내부 링크) -->
            <a
              v-if="slide.link_type === 'Y'"
              :style="btnStyle(slide)"
              class="btn compact round bold"
              :href="slide.link"
              :target="slide.link_new_window === 'Y' ? '_blank' : '_self'"
              v-html="slide.btn_title"
            ></a>
            <a
              v-if="slide.link_type === 'N'"
              :style="btnStyle(slide)"
              class="btn compact round bold"
              :href="slide.link"
              :target="slide.link_new_window === 'Y' ? '_blank' : '_self'"
              v-html="slide.btn_title"
            ></a>

            <!-- 페이지 번호 -->
            <div class="pageNum">
              <p><strong>{{slide.pagenum}}</strong> / {{allPageNum}}</p>
            </div>
          </div>
          <!-- 배경 이미지 -->
          <div class="bg">
            <img :src="slide.img" :style="imgStyle(slide)" :alt="slide.title || ''" />
          </div>
        </slide>
      </carousel>

      <!-- 비로그인 상태 -->
      <carousel
        v-else
        :perPage="1"
        :paginationPadding="2"
        :autoplay="true"
        :autoplayTimeout="5000"
        :loop="true"
        ref="logoutMain"
      >
        <slide
          v-for="(slide, index) in slider"
          v-if="slide.login_state === 'N' || slide.login_state === 'S'"
          :key="index"
          :data-index="index"
          class="slide"
        >
          <div class="sliderInner">
            <p v-if="slide.title" class="title" v-html="slide.title"></p>
            <p v-if="slide.content" class="desc" v-html="slide.content"></p>

            <!-- 외부 링크 -->
            <a
              v-if="slide.link_type === 'Y' && (slide.link.startsWith('http://') || slide.link.startsWith('https://'))"
              :style="btnStyle(slide)"
              class="btn compact round bold"
              :href="slide.link"
              :target="slide.link_new_window === 'Y' ? '_blank' : '_self'"
              v-html="slide.btn_title"
            ></a>

            <!-- 내부 링크 -->
            <router-link
              v-else-if="slide.link_type === 'Y'"
              :style="btnStyle(slide)"
              class="btn compact round bold"
              :to="slide.link"
              :target="slide.link_new_window === 'Y' ? '_blank' : '_self'"
              v-html="slide.btn_title"
            ></router-link>

            <!-- 버튼 없음 -->
            <span
              v-if="slide.link_type === 'N'"
              :style="btnStyle(slide)"
              class="btn compact round bold"
              v-html="slide.btn_title"
            ></span>

            <!-- 페이지 번호 -->
            <div class="pageNum">
              <p><strong>{{slide.pagenum}}</strong> / {{allPageNum}}</p>
            </div>
          </div>
          <!-- 배경 이미지 -->
          <div class="bg">
            <img :src="slide.img" :style="imgStyle(slide)" :alt="slide.title || ''" />
          </div>
        </slide>
      </carousel>
    </div>
    <!-- // 메인 슬라이더 -->

    <!-- 나의 G멤버스 (로그인시에만 노출) -->
    <div class="sectionBox mainLinks" v-if="isLogin">
      <div class="myinfoClub">
        <p class="lineTitle">나의 G멤버스</p>
        <div class="tileBox myinfoBox colorBlack">
          <ul class="info">
            <li>
              <span class="label point mr10">G포인트</span>
              <span class="value">{{point}}포인트</span>
            </li>
            <li>
              <span class="label money mr10">사용금액</span>
              <span class="value">{{totalPaymentAmount}}원</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- // 나의 G멤버스 -->

    <!-- 경기 일정 -->
    <div class="sectionBox mainLinks">
      <div class="titleBox">
        <span class="lineTitle">MATCH SCHEDULE</span>
        <a href="https://www.gyeongnamfc.com/match/match.php" target="_blank">더보기</a>
      </div>
      <carousel
        :perPage="1"
        :paginationActiveColor="'#515257'"
        :pagination-color="'rgba(81, 82, 87, 0.2)'"
        :paginationPadding="2"
        :navigationEnabled="false"
        ref="myCarousel"
      >
        <slide
          v-for="(slide, index) in matchList"
          :key="index"
          :data-index="index"
          class="slide"
        >
          <div class="sliderInner">
            <div class="matchBox">
              <!-- 경기 상단 -->
              <div class="matchBoxTop">
                <div class="matchBoxLeft">
                  <img :src="slide.set_home_logo">
                  <p>{{slide.home_team_name}}</p>
                </div>
                <div class="matchBoxMiddle">
                  <p v-if="slide.audience === 0">VS</p>
                  <p v-else>{{slide.home_team_goal}} : {{slide.away_team_goal}}</p>
                </div>
                <div class="matchBoxRight">
                  <img :src="slide.set_away_logo">
                  <p>{{slide.away_team_name}}</p>
                </div>
              </div>
              <!-- 경기 하단 -->
              <div class="matchBoxBottom">
                <p class="time">{{slide.set_game_date}}({{slide.yoil}}) {{slide.set_game_time}}</p>
                <p class="place">@{{slide.field_name}}</p>
              </div>

              <!-- 티켓 예매 버튼 (홈팀이 K20이고, 경기 전일 경우만 노출) -->
              <div v-show="slide.audience === 0 && slide.home_team === 'K20'">
                <router-link :to="{name: 'ticket'}" class="ticketBtn">티켓예매</router-link>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
    <!-- // 경기 일정 -->

    <!-- 링크 영역 -->
    <div class="sectionBox mainLinks" style="padding-top: 0">
      <p class="lineTitle">LINK</p>
      <div>
        <a
          v-for="(link, index) in links"
          :key="index"
          :href="link.link"
          :target="link.link_new_window === 'N' ? '_self' : '_blank'"
          style="overflow: hidden; text-overflow: ellipsis"
          class="btn full LinkBtn"
        >
          <img v-if="link.icon_type === 'image'" :src="link.icon">
          <span v-if="link.icon_type === 'emoji'" v-html="link.icon" class="emoji"></span>
          {{link.title}}
        </a>

        <!-- 이벤트 배너 슬라이더 -->
        <div ref="carousel" class="mt20">
          <carousel
            :perPage="1"
            :paginationPadding="2"
            :pagination-enabled="false"
            :autoplay="true"
            :autoplayTimeout="3000"
            :loop="true"
            :mouse-drag="true"
            :navigationEnabled="false"
          >
            <slide
              v-for="(slide, index) in eventBanner"
              :key="index"
              :data-index="index"
              class="slide"
            >
              <div class="bg">
                <a :href="slide.link" :target="slide.link_new_window === 'N' ? '_self' : '_blank'">
                  <img
                    style="width: -webkit-fill-available; object-fit: fill; margin-right: 0; height: 150px; border-radius: 10px;"
                    :src="slide.image"
                    :alt="slide.title || ''"
                  />
                </a>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
    <!-- // 링크 영역 -->

    <!-- 채널 영역 -->
    <div class="sectionBox mainChannel">
      <p class="lineTitle">CHANNEL</p>

      <!-- 탭 -->
      <div class="tabs">
        <div class="tabBox">
          <button
            v-for="tab in tabs"
            :key="tab.id"
            type="button"
            class="btnTab"
            :class="{ active: tab.id === current }"
            :data-tab="tab.id"
            @click="feedTab(tab.id)"
          >
            {{ tab.name }}
          </button>
        </div>
      </div>

      <!-- 채널 이미지 리스트 -->
      <div class="channels">
        <div v-for="(data, index) in visibleImages" :key="index" class="imgBox">
          <a :href="data.link_url || '#'" target="_blank">
            <img :src="data.thumbnail_img">
          </a>
        </div>
      </div>

      <!-- 더보기 버튼 -->
      <div v-if="showButton">
        <button v-if="feedsList.length > 4" @click="showMore" class="viewMore">더보기</button>
      </div>
    </div>
    <!-- // 채널 영역 -->

    <!-- G MEMBERS 소개 영역 -->
    <div class="sectionBox colorBg mainClub">
      <div class="inner">
        <div class="innerText">
          <div class="logo"></div>
          <p class="lineTitle"><strong>G</strong> MEMBERS</p>
          <p>
            경남FC 팬을 위한 공간 'G멤버스'<br />
            나의 관람 정보를 확인하고 홈경기 혜택을 받아보세요!
          </p>
        </div>
        <div class="lineBtns">
          <router-link
            v-for="(link, index) in clubFilter"
            :key="index"
            :to="{ name: link.link }"
            :data-club="link.id"
            class="lineBtn"
          >
            <span class="bold ml10">{{link.club}}</span>
          </router-link>
        </div>
      </div>
    </div>
    <!-- // G MEMBERS 소개 -->
  </div>
</template>

<script>
import http from '@/api/index'
import regExp from '@/common/regExp'
import dayjs from 'dayjs'
import imgPath from '@/library/imgPath'

export default {
  name: 'Main',

  // 부모 컴포넌트에서 로그인 여부를 전달받음
  props: [
    'isLogin'
  ],

  // 컴포넌트 생성 시 실행
  created () {
    this.init() // 메인 배너, 링크, 경기 일정, 이벤트 배너 초기화
    this.initChannel() // 채널(뉴스/유튜브/인스타그램) 초기화
    if (localStorage.getItem('token')) {
      this.initLoginData() // 토큰이 있으면 사용자 데이터 로드
    }
    console.log(this.setLogin)
  },

  computed: {
    // 로그인 여부에 따라 'Y' 또는 'N' 반환
    setLogin () {
      if (this.isLogin) {
        return 'Y'
      } else {
        return 'N'
      }
    },

    // Vuex에서 사용자 포인트 조회
    point () {
      return this.$store.state.user.point
    },

    // Vuex에서 총 사용 금액 조회
    totalPaymentAmount () {
      return this.$store.state.user.userTotalPayment
    },

    // Vuex에서 경기 예매율 조회 (null이면 0으로 처리)
    rate () {
      const rate = this.$store.state.gameData.totalRate
      return rate === null ? 0 : regExp.comma(rate)
    },

    // 로그인 상태에 따라 메뉴 필터링
    // - 미로그인: 로그아웃 제거
    // - 로그인: 로그인 제거
    clubFilter () {
      const club = this.club
      const isLogin = this.isLogin
      return club.filter(x => {
        return !(x.id === 'logout' && !isLogin) &&
          !(x.id === 'login' && isLogin)
      })
    },

    // 현재 탭에 따라 표시할 피드 리스트 반환
    feedsList () {
      const tab = this.current
      const validTab = this.tabs.map(x => x.id)
      let feeds

      if (tab === 'all') {
        feeds = this.allList
      }
      if (tab === 'news') {
        feeds = this.newsList
      }
      if (tab === 'instagram') {
        feeds = this.instagramList
      }
      if (tab === 'youtube') {
        feeds = this.youtubeList
      }

      // 현재 탭과 일치하는 데이터만 반환
      const list = feeds.filter(x => {
        if (tab === 'all') {
          return true
        } else {
          return x.type === tab
        }
      })
      return list
    },

    // 현재 보여줄 이미지 리스트 (더보기 버튼과 연동)
    visibleImages () {
      return this.feedsList.slice(0, this.imagesToShow)
    }
  },

  data () {
    return {
      userName: '',
      userPoint: 0,
      totalRate: 0,

      // 메인 슬라이더/링크/채널/배너 관련 데이터
      slider: [],
      links: [],
      feeds: [],
      allList: [],
      youtubeList: [],
      instagramList: [],
      newsList: [],
      eventBanner: [],

      // 채널 관련 상태
      current: 'all',
      imagesToShow: 4, // 더보기 클릭 전 기본 노출 이미지 수
      showButton: true, // 더보기 버튼 노출 여부

      // 슬라이더 페이지 수
      loginPageNum: 0,
      logoutPageNum: 0,
      allPageNum: 0,

      // 경기 일정 리스트
      matchList: [],
      gmambersTotalRate: {},

      // 외부 채널 링크
      channel: [
        { id: 'homepage', channel: '홈페이지', link: 'https://www.gyeongnamfc.com/main.php' },
        { id: 'youtube', channel: '유튜브', link: 'https://www.youtube.com/channel/UCTvoVkwegdQSCMX4PT06rpg' },
        { id: 'instagram', channel: '인스타그램', link: 'https://www.instagram.com/gyeongnamfc/' },
        { id: 'facebook', channel: '페이스북', link: 'https://www.facebook.com/GyeongnamFC' }
      ],

      // 채널 탭 정의
      tabs: [
        { id: 'all', name: '전체', link: '/', active: true },
        { id: 'news', name: '구단뉴스', link: '/', active: false },
        { id: 'youtube', name: '유튜브', link: '/', active: false },
        { id: 'instagram', name: '인스타그램', link: '/', active: false }
      ],

      // 메뉴 리스트
      club: [
        { id: 'login', club: '로그인', link: 'login' },
        { id: 'logout', club: '로그아웃', link: 'logout' },
        { id: 'ticket', club: '티켓예매', link: 'ticket' },
        { id: 'attendance', club: '출석체크', link: 'attendance' },
        { id: 'reservation', club: '예매내역 조회', link: 'reservationList' },
        { id: 'event', club: '이벤트 신청', link: 'eventHistory' },
        { id: 'membership', club: '시즌권', link: 'membership' },
        { id: 'survey', club: '설문조사 참여', link: 'surveyHistory' },
        { id: 'point', club: 'G포인트 조회', link: 'pointHistory' },
        { id: 'stadium', club: '경기장 안내', link: 'stadium'},
        { id: 'coupon', club: '쿠폰 조회', link: 'couponHistory' }
      ]
    }
  },

  methods: {
    // 메인 페이지 초기화
    init () {
      // 메인 배너 데이터
      http.get('/main/slide').then(res => {
        if (!localStorage.getItem('token')) {
          this.$store.state.login = false
        }
        this.slider = res.data

        // 슬라이드 페이지 번호 설정
        this.slider.map(el => {
          if (el.login_state === 'N' || el.login_state === 'S') {
            el.pagenum = ++this.logoutPageNum
          }
          if (el.login_state === 'Y' || el.login_state === 'S') {
            el.pagenum = ++this.loginPageNum
          }
          el.target = 'self'

          // 회원가입 링크 수정 (외부 페이지로 연결)
          if (el.link === '/join') {
            el.link = 'https://www.gyeongnamfc.com/member/signup_1.php'
            el.target = '_blank'
          }
          return el
        })

        // 총 페이지 수 저장
        this.isLogin ? this.allPageNum = this.loginPageNum : this.allPageNum = this.logoutPageNum
      })

      // 메인 링크 데이터
      http.get('/main/link').then(res => {
        if (res && res.data) {
          this.links = res.data.filter(el => el.login_state === this.setLogin)
        }
      })

      // 경기 일정 데이터
      http.get('/game').then(res => {
        const data = res.data.data
        let selectedNextMatch
        let selectedLastMatch

        // 경기 개수별로 다른 조합을 matchList에 저장
        if (data.future_game.length === 0) {
          this.$refs.myCarousel.navigateTo = 0
          selectedLastMatch = data.past_game.slice(-3)
          this.matchList.push(...selectedLastMatch)
        }
        if (data.future_game.length === 1) {
          this.$refs.myCarousel.navigateTo = 1
          selectedNextMatch = data.future_game.slice(0, 1)
          selectedLastMatch = data.past_game.slice(-2)
          this.matchList.push(...selectedLastMatch, ...selectedNextMatch)
        }
        if (data.future_game.length > 1 && data.past_game.length > 0) {
          this.$refs.myCarousel.navigateTo = 1
          selectedNextMatch = data.future_game.slice(0, 2)
          selectedLastMatch = data.past_game.slice(-1)
          this.matchList.push(...selectedLastMatch, ...selectedNextMatch)
        }
        if (data.future_game.length > 1 && data.past_game.length === 0) {
          this.$refs.myCarousel.navigateTo = 1
          selectedNextMatch = data.future_game.slice(0, 3)
          this.matchList.push(...selectedNextMatch)
        }

        // 날짜/시간/로고 등 데이터 가공
        this.matchList.map(el => {
          el.set_game_date = dayjs(el.game_date).format('YYYY.MM.DD')
          el.set_game_time = el.game_time.slice(0, 5)
          if (el.home_team === 'K07') {
            el.home_team = 'K07_new'
          }
          if (el.away_team === 'K07') {
            el.away_team = 'K07_new'
          }
          el.set_home_logo = imgPath.setTeamLogo(el.home_team)
          el.set_away_logo = imgPath.setTeamLogo(el.away_team)
          return el
        })
      })

      // 이벤트 배너 데이터
      http.get('/main/banner').then(res => {
        const eventBanner = res.data
        this.eventBanner = eventBanner.filter(el => el.login_state === this.setLogin)
      })
    },

    // 채널 데이터 초기화 (뉴스/유튜브/인스타그램)
    async initChannel () {
      // 전체
      const allList = await http.get('/notice/news')
      allList.data.data.map(el => {
        el.type = 'all'
        el.setTime = el.w_date
        return el
      })
      this.allList = allList.data.data

      // 구단뉴스
      const newsList = await http.get('/notice/news?type=news')
      newsList.data.data.map(el => {
        el.type = 'news'
        el.setTime = el.w_date
        return el
      })
      this.newsList = newsList.data.data

      // 유튜브
      const youtubeList = await http.get('/notice/news?type=youtube&page=1')
      youtubeList.data.data.map(el => {
        el.type = 'youtube'
        el.setTime = el.reg_date
        return el
      })
      this.youtubeList = youtubeList.data.data

      // 인스타그램
      const instagramList = await http.get('/notice/news?type=instagram&page=1')
      instagramList.data.data.map(el => {
        el.type = 'instagram'
        el.setTime = el.reg_date
        return el
      })
      this.instagramList = instagramList.data.data
    },

    // 슬라이드 버튼 스타일 지정
    btnStyle (data) {
      const result = {}
      if (data.btn_color) {
        result.backgroundColor = '#' + data.btn_color
      }
      if (data.btn_txt_color) {
        result.color = '#' + data.btn_txt_color
      }
      if (!data.btn_title) {
        result.display = 'none'
      }
      if (result.title) {
        result.display = 'block'
      }
      return result
    },

    // 슬라이드 이미지 스타일 지정
    imgStyle (data) {
      const result = {}
      if (data.btn_title === '' && data.content === '') {
        result.opacity = 1
      }
      return result
    },

    // 메뉴 항목 노출 여부 판단
    status (id) {
      let result = true
      const isLogin = this.isLogin
      if (id === 'join' && isLogin) {
        result = false
      } else if ((id === 'mypage' || id === 'logout') && !isLogin) {
        result = false
      }
      return result
    },

    // 채널 탭 전환
    feedTab (type) {
      this.current = type
      this.imagesToShow = 4
      this.showButton = true
    },

    // 더보기 버튼 클릭 시 모든 이미지 표시
    showMore () {
      this.imagesToShow = this.feedsList.length
      this.showButton = false
    },

    // 로그인 사용자 정보/경기 데이터 가져오기
    initLoginData () {
      try {
        this.$store.dispatch('getUserInfo')
      } catch (error) {
        console.error('main dispatch getUserInfo', error)
      }
      try {
        this.$store.dispatch('getUserGameData')
      } catch (error) {
        console.error('main dispatch getUserGameData', error)
      }
    }
  }
}
</script>
